import React from "react";
import styled from "styled-components";
import { uniqBy } from "lodash";
import { CheckboxDropdownItem } from "@sonder/ui/source/styled/fragments/CheckboxDropdownItem";
import { RadioDropdownItem } from "@sonder/ui/source/styled/fragments/RadioDropdownItem";
import { UserCardInDropdownItem } from "@sonder/ui/source/styled/fragments/UserCardInDropdownItem";

const NoMatches = styled.span`
  flex-grow: 1;
  padding: 0 1rem 1rem;
  text-align: center;
`;

const StyledList = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  > button {
    border-color: transparent;
    margin: 0.1rem 0;
  }
`;

interface OnSelectResult {
  itemId: string;
  nextAssigneeId: string | null;
}
interface AssigneePickerListProps {
  assigneeIds: string[];
  className?: string;
  hasMultipleSupport?: boolean | null;
  isDisabled?: boolean;
  onSelect(result: OnSelectResult): void;
  users?: User[];
}
export const AssigneePickerList = ({
  assigneeIds,
  className,
  hasMultipleSupport,
  isDisabled,
  onSelect = () => undefined,
  users = [],
}: AssigneePickerListProps) => (
  <StyledList className={className}>
    {users.length === 0 ? (
      <NoMatches>No matches.</NoMatches>
    ) : (
      uniqBy(users, "id").map(item => {
        const selected = assigneeIds.includes(item.id);

        const CheckboxOrRadioDropdownItem = hasMultipleSupport
          ? CheckboxDropdownItem
          : RadioDropdownItem;

        return (
          <CheckboxOrRadioDropdownItem
            checked={selected}
            data-testid="assignee-picker-dropdown-item"
            disabled={isDisabled}
            key={item.id}
            onClick={() => {
              requestAnimationFrame(() =>
                onSelect({
                  itemId: item.id,
                  nextAssigneeId: selected ? null : item.id,
                }),
              );
            }}
          >
            <UserCardInDropdownItem
              imageUrl={item.avatarUrl}
              name={item.name}
            />
          </CheckboxOrRadioDropdownItem>
        );
      })
    )}
  </StyledList>
);
